import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useIntl } from 'react-intl';

import { Event } from 'app/shared/typings';
import { Typography } from 'app/shared/components/atoms';
import { Modal } from 'app/shared/components/molecules';
import { UPDATE_EVENT_ATTENDEE_STATE_FOR_USER } from 'app/fan/graphql/eventAttendees/mutations';
import { useEventPageContext } from 'app/fan/context/EventPage';

interface Props {
  event: Event;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onError: () => void;
}

export const ConfirmCantGoModal: React.FC<React.PropsWithChildren<Props>> = ({
  event,
  isOpen,
  setIsOpen,
  onError,
}) => {
  const { formatMessage } = useIntl();
  const [isConfirmCantGoLoading, setIsConfirmCantGoLoading] = useState(false);
  const { refetchEventAttendee } = useEventPageContext();

  const [updateEventAttendeeStateForUser] = useMutation(
    UPDATE_EVENT_ATTENDEE_STATE_FOR_USER
  );

  const declineEvent = async () => {
    setIsConfirmCantGoLoading(true);
    try {
      await updateEventAttendeeStateForUser({
        variables: { eventId: Number(event.id), state: 'cant_go' },
      });
      refetchEventAttendee && (await refetchEventAttendee());
      setIsConfirmCantGoLoading(false);
      setIsOpen(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      onError();
      setIsConfirmCantGoLoading(false);
    }
  };

  return (
    <Modal
      data-qaid="confirm-cant-go-modal"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={formatMessage({
        id: 'event.applyFlow.confirmCantGoModal.title',
      })}
      isFullscreenMobile={false}
      primaryCtaText={formatMessage({ id: 'event.applyFlow.cantGo' })}
      isPrimaryCtaLoading={isConfirmCantGoLoading}
      onClickPrimaryCta={declineEvent}
      secondaryCtaText={formatMessage({
        id: 'event.applyFlow.confirmCantGoModal.cancel',
      })}
      onClickSecondaryCta={() => setIsOpen(false)}
    >
      <Typography>
        {formatMessage({ id: 'event.applyFlow.weWillMissYou' })}
      </Typography>
    </Modal>
  );
};
